// Shared amount mask/unmask toggle. Replaces ~13 copy-pasted inline buttons
// across the Advisor hub + setup/plan/history subpages (each was a sub-44px
// `px-2 py-1` button — see docs/audits 2026-07-01 P1-4 touch-target audit).
// Renders a 44×44 icon button (Eye = amounts hidden/tap to reveal, EyeOff =
// amounts visible/tap to hide) to meet the mobile 44px touch-target minimum.
import { Eye, EyeOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function MaskToggle({
  masked,
  onClick,
  className = '',
}: {
  masked: boolean;
  onClick: () => void;
  className?: string;
}) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={masked ? t('advisor.toggleMaskShow') : t('advisor.toggleMaskHide')}
      className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-md border bg-background text-muted-foreground hover:bg-muted ${className}`}
    >
      {masked ? <Eye size={20} /> : <EyeOff size={20} />}
    </button>
  );
}
